<template>
  <footer class="legal-brand-strip legal-site-footer" role="contentinfo">
    <div class="legal-footer-wrap">
      <div class="legal-footer-row">
        <nav class="legal-footer-col legal-footer-col--start" aria-label="Legal">
          <template v-if="active === 'privacy'">
            <span class="legal-footer-current">Privacy Policy</span>
          </template>
          <router-link v-else :to="{ name: 'privacy-policy' }" class="legal-footer-link">Privacy Policy</router-link>
          <span class="legal-footer-sep" aria-hidden="true">·</span>
          <template v-if="active === 'terms'">
            <span class="legal-footer-current">Terms &amp; Conditions</span>
          </template>
          <router-link v-else :to="{ name: 'terms-and-conditions' }" class="legal-footer-link"
            >Terms &amp; Conditions</router-link
          >
        </nav>
        <div class="legal-footer-col legal-footer-col--center">
          <span class="legal-footer-copy"
            >&copy; {{ currentYear }} CuraScript (Pty) Ltd. All rights reserved.</span
          >
        </div>
        <div class="legal-footer-col legal-footer-col--end">
          <span class="legal-footer-meta">
            <span class="legal-footer-label">Contact</span>
            <a href="mailto:info@curascript.co.za" class="legal-footer-link-inline">info@curascript.co.za</a>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LegalPageFooter',
  props: {
    /** Which page is active: highlights label, other is a link */
    active: {
      type: String,
      required: true,
      validator: (v) => ['privacy', 'terms'].includes(v),
    },
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
